import React, { useEffect, useState } from "react";
import {
	AntdTable,
	BodyContainer,
	Container,
	HeaderContainer,
	Section,
	StepContainer,
	TextContainer,
	CompaginationDiv,
	AntdInput,
} from "./styles";
import { IoIosArrowRoundBack } from "react-icons/io";
import { COLORS, SIZES, Typo } from "../../../../../../../layout/theme";
import Image from "../../../../../../../common/image/Image";
import DEFAULTUSER from "../../../../../../../../assets/images/SinImagenDeUsuario.jpeg";
import moment from "moment";
import { CONSTANTS } from "../../../../../../../../utils/constants";
import { Spin, Button } from "antd";
import { BsDownload } from "react-icons/bs";
import { download_crm_user_detail } from "../../../../../../../../api/endpoints/users";
import CustomAntdTooltip from "../../../../../../../common/custom-antd-tooltip/CustomAntdTooltip";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

export default function Step2UserDetail({
	stepData,
	handleBackStep,
	handleChangeStep,
	setSelectedSeller,
	searchInfo,
	handleDecrement,
	handlePageChange,
	handleIncrement,
	paginationInputValue,
	setPaginationInputValue,
}) {
	const [toggleTable, setToggleTable] = useState(true);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const columns = [
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Punto de venta
				</div>
			),
			width: 280,
			dataIndex: "name",
			render: (value, record) => (
				<TextContainer
					pointer
					onClick={() =>
						handleChangeStep(
							record?.id,
							CONSTANTS.ERP_MODULE_USERS_STEP_5,
							record?.clientId,
							record?.userId
						)
					}
				>
					<Typo level={7} type="secondary">
						{value}
					</Typo>
				</TextContainer>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Cuit
				</div>
			),
			width: 110,
			dataIndex: "cuit",
			render: (value, record) => (
				<Typo level={7} type="muted">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Razón social
				</div>
			),
			dataIndex: "businessName",
			render: (value, record) => (
				<TextContainer>
					<Typo level={7} type="muted">
						{value}
					</Typo>
				</TextContainer>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Dirección
				</div>
			),
			dataIndex: "address",
			render: (value, record) => (
				<TextContainer>
					<Typo level={7} type="muted">
						{value}
					</Typo>
				</TextContainer>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Provincia
				</div>
			),
			dataIndex: "province",
			render: (value, record) => (
				<TextContainer>
					<Typo level={7} type="muted">
						{value}
					</Typo>
				</TextContainer>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Localidad
				</div>
			),
			dataIndex: "locality",
			render: (value, record) => (
				<TextContainer>
					<Typo level={7} type="muted">
						{value}
					</Typo>
				</TextContainer>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Pedidos
				</div>
			),
			width: 80,
			dataIndex: "totalOrders",
			render: (value, record) => (
				<Typo level={7} type="muted">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Fecha última orden
				</div>
			),
			dataIndex: "lastOrderDate",
			render: (value, record) => (
				<Typo level={7} type="muted">
					{moment(value).format("DD-MM-YYYY") !== "01-01-0001"
						? moment(value).format("DD-MM-YYYY")
						: null}
				</Typo>
			),
		},
	];

	const handleDownloadFile = async () => {
		setLoading(true);
		try {
			const _userData = [
				{
					name: stepData?.firstName + " " + stepData?.lastName,
					email: stepData?.email,
					phone: stepData?.phone,
					totalRoutes: stepData?.routes?.length,
					totalOrders: stepData?.orders?.length,
				},
			];

			const _userRoute = stepData?.routes?.map((r) => ({
				name: r.name,
				cuit: r.cuit,
				businessName: r.businessName,
				address: r.address,
				province: r.province,
				locality: r.locality,
				totalOrders: r.totalOrders,
				lastOrderDate: moment(r.lastOrderDate).format("DD-MM-YYYY"),
			}));

			const res = await download_crm_user_detail({
				userToExport: _userData,
				userRoutesToExport: _userRoute,
			});
			const href = URL.createObjectURL(res);

			const link = document.createElement("a");
			link.href = href;

			const _fileName =
				"Ficha_Vendedor_" +
				stepData?.firstName +
				"_" +
				stepData?.lastName +
				"_" +
				moment().format("DD-MM-YYYY") +
				".xlsx";
			link.setAttribute("download", _fileName);
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (err) {
			console.log(err);
		} finally {
			setLoading(false);
		}
	};

	return (
		<StepContainer>
			<HeaderContainer>
				<Section
					onClick={() => {
						setSelectedSeller(null);
						handleBackStep(1);
					}}
					style={{ cursor: "pointer", justifyContent: "start" }}
				>
					<IoIosArrowRoundBack size={19} color={COLORS.Secondary} />
					<Typo type="secondary" level={7}>
						Volver
					</Typo>
				</Section>
				<Section style={{ marginLeft: -180 }}>
					<Typo type="dark" level={6}>
						Ficha vendedor
					</Typo>
				</Section>
				<Section>
					{loading ? (
						<Spin size="small" />
					) : (
						<CustomAntdTooltip
							placement="left"
							width="105px"
							tooltipContent={[
								{
									body: "Exportar datos",
								},
							]}
						>
							<BsDownload
								size={18}
								color={COLORS.Secondary}
								style={{ cursor: "pointer" }}
								onClick={handleDownloadFile}
							/>
						</CustomAntdTooltip>
					)}
				</Section>
			</HeaderContainer>
			<BodyContainer>
				<Container
					style={{
						width: 100,
						minWidth: 80,
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Image
						width={60}
						height={60}
						src={stepData?.photoUrl || DEFAULTUSER}
						alt={stepData?.firstName}
						borderRadius={40}
					/>
				</Container>
				<Container>
					<Section>
						<Typo type="grey" level={7}>
							Nombre:
						</Typo>
						<Typo type="mediumGrey" level={7}>
							{stepData?.firstName}
						</Typo>
					</Section>
					<Section>
						<Typo type="grey" level={7}>
							Apellido:
						</Typo>
						<Typo type="mediumGrey" level={7}>
							{stepData?.lastName}
						</Typo>
					</Section>
					{/* 					
					{stepData?.orders?.length > 0 && stepData?.routes?.length === 0 && (
						<Section>
							<Typo type="grey" level={7}>
								Ordenes totales:
							</Typo>
							<Typo
								type="secondary"
								level={6}
								style={{ cursor: "pointer" }}
								onClick={() =>
									handleChangeStep(
										stepData?.id,
										CONSTANTS.ERP_MODULE_USERS_STEP_3,
										"",
										""
									)
								}
							>
								{stepData?.orders?.length}
							</Typo>
						</Section>
					)} */}
				</Container>
				<Container>
					<Section>
						<Typo type="grey" level={7}>
							Correo electrónico:
						</Typo>
						<Typo type="mediumGrey" level={7}>
							{stepData?.email}
						</Typo>
					</Section>
					<Section>
						<Typo type="grey" level={7}>
							Teléfono:
						</Typo>
						<Typo type="mediumGrey" level={7}>
							{stepData?.phone}
						</Typo>
					</Section>
				</Container>
				<Container
					style={{
						gap: 10,
					}}
				>
					{stepData?.routes?.length > 0 && (
						<Section>
							<Typo type="grey" level={7}>
								Clientes asociados:
							</Typo>
							<Typo
								type="secondary"
								level={6}
								style={{ cursor: "pointer" }}
								onClick={() => setToggleTable((prev) => !prev)}
							>
								{stepData?.routes?.length}
							</Typo>
						</Section>
					)}
					{stepData?.orders?.length > 0 && stepData?.routes?.length > 0 && (
						<Section>
							<Typo type="grey" level={7}>
								Ordenes totales:
							</Typo>
							<Typo
								type="secondary"
								level={6}
								style={{ cursor: "pointer" }}
								onClick={() =>
									handleChangeStep(
										stepData?.id,
										CONSTANTS.ERP_MODULE_USERS_STEP_3,
										"",
										""
									)
								}
							>
								{stepData?.orders?.length}
							</Typo>
						</Section>
					)}
				</Container>
			</BodyContainer>
			{toggleTable && stepData?.routes?.length > 0 && (
				<Section style={{ padding: "10px 10px 0 10px" }}>
					<Typo type="grey" level={7}>
						Clientes asociados
					</Typo>
				</Section>
			)}
			{toggleTable && stepData?.routes?.length > 0 && (
				<BodyContainer style={{ padding: "5px 10px", flexDirection: "column" }}>
					<AntdTable
						dataSource={stepData?.routes || []}
						loading={!stepData}
						columns={columns}
						pagination={false}
						scroll={{ y: "1020px" }}
					/>
					{searchInfo && searchInfo.totalSellers > 0 && (
						<CompaginationDiv>
							{searchInfo.actualPage !== 1 && (
								<Button
									size="small"
									shape="circle"
									onClick={() => handleDecrement("ROUTES")}
								>
									<LeftOutlined />
								</Button>
							)}
							<AntdInput
								step={1}
								min={1}
								max={searchInfo.totalRoutesPages}
								onPressEnter={(e) => handlePageChange(e, "ROUTES")}
								onChange={(e) =>
									setPaginationInputValue(e.target.value.toString())
								}
								defaultValue={paginationInputValue.toString()}
								value={paginationInputValue.toString()}
								addonAfter={`/ ${searchInfo.totalRoutesPages}`}
								style={{
									width: ` ${
										searchInfo.totalRoutesPages > 99 ? "76px" : "66px"
									}`,
								}}
							/>
							{searchInfo.actualPage < searchInfo.totalRoutesPages && (
								<Button
									size="small"
									shape="circle"
									onClick={() => handleIncrement("ROUTES")}
									disabled={
										searchInfo.actualPage === searchInfo.totalRoutesPages
											? true
											: false
									}
								>
									<RightOutlined />
								</Button>
							)}
						</CompaginationDiv>
					)}
				</BodyContainer>
			)}
		</StepContainer>
	);
}
